function updateSliderPaging(){

  $(".sliderPaging").each(function(){
    var lng = $(this).children("li").length;

    $(this).children("li").hide();
    $(this).children("li").first().show();
    $(this).children("li").last().show();
    $(this).children(".slick-active").show();
    $(this).children(".slick-active").prev().show();
    $(this).children(".slick-active").next().show();

  })

}

function updateSliderPagingDots($slider, currentSlide){

  var lng = $slider.find(".sliderPaging").children("li").length;

  $slider.find(".sliderPaging").removeClass("pagingStart");
  $slider.find(".sliderPaging").removeClass("pagingEnd");

  if(currentSlide <= 2){
    $slider.find(".sliderPaging").addClass("pagingStart");
  }
  else if (currentSlide >= lng-3){
    $slider.find(".sliderPaging").addClass("pagingEnd");
  }
}
